export class NuevaFacturaDTO {
    constructor(
        public idCliente: number,
        public numero: string,
        public fecha: string,
        public montoBrutoCLP: number,
        public montoIVA: number,
        public rutFacturado: string,
        public idOrdenesCompra: number[]
    ) {
        this.idCliente = idCliente;
        this.numero = numero;
        this.fecha = fecha;
        this.montoBrutoCLP = montoBrutoCLP;
        this.montoIVA = montoIVA;
        this.rutFacturado = rutFacturado;
        this.idOrdenesCompra = idOrdenesCompra;
    }
}


